import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, putAction } from '@/api/manage';
export default {
  name: 'DepartSelect',
  props: {
    title: {
      type: String,
      default: "部门选择",
      required: false
    },
    closable: {
      type: Boolean,
      default: false,
      required: false
    },
    username: {
      type: String,
      default: "",
      required: false
    }
  },
  watch: {
    username: function username(val) {
      if (val) {
        this.loadDepartList();
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      departList: [],
      departSelected: "",
      validate_status: "",
      currDepartName: ""
    };
  },
  created: function created() {//this.loadDepartList()
  },
  methods: {
    loadDepartList: function loadDepartList() {
      var _this = this;

      return new Promise(function (resolve) {
        var url = "/sys/user/getCurrentUserDeparts";
        _this.currDepartName = '';
        getAction(url).then(function (res) {
          if (res.success) {
            var departs = res.result.list;
            var orgCode = res.result.orgCode;

            if (departs && departs.length > 0) {
              var _iterator = _createForOfIteratorHelper(departs),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var i = _step.value;

                  if (i.orgCode == orgCode) {
                    _this.currDepartName = i.departName;
                    break;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }

            _this.departSelected = orgCode;
            _this.departList = departs;

            if (_this.currDepartName) {
              _this.title = "部门切换（当前部门 : " + _this.currDepartName + "）";
            }
          }

          resolve();
        });
      });
    },
    close: function close() {
      this.departClear();
    },
    departOk: function departOk() {
      var _this2 = this;

      if (!this.departSelected) {
        this.validate_status = 'error';
        return false;
      }

      var obj = {
        orgCode: this.departSelected,
        username: this.username
      };
      putAction("/sys/selectDepart", obj).then(function (res) {
        if (res.success) {
          _this2.departClear();
        }
      });
    },
    show: function show() {
      var _this3 = this;

      //如果组件传值username此处就不用loadDepartList了
      this.loadDepartList().then(function () {
        _this3.visible = true;

        if (!_this3.departList || _this3.departList.length <= 0) {
          _this3.$message.warning("您尚未设置部门信息!");

          _this3.departClear();
        }
      });
    },
    departClear: function departClear() {
      this.departList = [];
      this.departSelected = "";
      this.visible = false;
      this.validate_status = '';
      this.currDepartName = "";
    }
  }
};